import { catalogStages } from "@/mocks/content";

export default function Catalog() {
  return (
    <section id="catalog" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-3xl">
          <span className="text-xs md:text-sm font-label font-medium tracking-widest text-accent-700 uppercase">
            Course catalog
          </span>
          <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
            课程目录总览：五个阶段，一条主线
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700 font-body">
            整个「秘密教学」系列按学习逻辑划分为五个阶段。下面按顺序列出每个阶段涵盖的课次、
            条目数量、大致时长以及它解决的问题，方便你判断自己现在应该从哪一阶段进入。
          </p>
        </div>

        <div className="mt-10 space-y-4">
          {catalogStages.map((stage, index) => (
            <article
              key={stage.id}
              className="rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
                <div className="flex items-center gap-4 md:w-[280px] shrink-0">
                  <span className="font-heading text-3xl md:text-4xl font-black text-primary-500/70 w-12 text-center shrink-0">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-950">
                      {stage.name}
                    </h3>
                    <p className="mt-1 text-xs md:text-sm text-foreground-600 font-label">
                      {stage.range}
                    </p>
                  </div>
                </div>

                <div className="flex-1 md:border-l md:border-background-200/70 md:pl-6">
                  <p className="text-sm leading-relaxed text-foreground-700 font-body">
                    {stage.purpose}
                  </p>
                  <div className="mt-3 flex flex-wrap gap-2">
                    {stage.keywords.map((kw) => (
                      <span
                        key={kw}
                        className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-label"
                      >
                        {kw}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="flex md:flex-col gap-3 md:gap-2 md:w-[140px] shrink-0 md:text-right">
                  <div className="flex-1 md:flex-none rounded-md bg-background-100 px-3 py-2">
                    <p className="text-xs text-foreground-500 font-label">条目</p>
                    <p className="font-heading font-semibold text-foreground-950 text-sm md:text-base">
                      {stage.count}
                    </p>
                  </div>
                  <div className="flex-1 md:flex-none rounded-md bg-background-100 px-3 py-2">
                    <p className="text-xs text-foreground-500 font-label">时长</p>
                    <p className="font-heading font-semibold text-foreground-950 text-sm md:text-base">
                      {stage.duration}
                    </p>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-8 text-xs md:text-sm text-foreground-500 font-body leading-relaxed">
          说明：上表为对系列结构的归纳整理，各阶段时长按课程标注汇总，实际资源以官方发布的
          内容为准。下方「课程导航」提供更细的逐课目录，可按阶段筛选。
        </p>
      </div>
    </section>
  );
}